/* eslint-disable import/first */
import '@babel/polyfill';
import React, { lazy, Suspense } from 'react';
import camelCase from 'lodash.camelcase';
import { ApolloProvider } from 'react-apollo';
import ReactDOM from 'react-dom';
/* eslint-enable import/first */

import createClient from './graphql/clientSetup';
import WithUserState from './components/WithUserState/WithUserState';
import { initiateConfig } from './config';

const componentMap = {
    PersonalInvestorNavigation: lazy(() =>
        import('./components/MegaMenu/PersonalInvestorNavigation')
    ),
    RowValue: lazy(() => import('./components/RowValue/RowValue')),
    PieChart: lazy(() => import('./components/PieChart/PieChart')),
    CollegeSavingsPricesTable: lazy(() =>
        import('./components/CollegeSavingsPricesTable/CollegeSavingsPricesTable')
    ),
    CollegeSavingsReturnsTable: lazy(() =>
        import('./components/CollegeSavingsReturnsTable/CollegeSavingsReturnsTable')
    ),
    AlaskaPricesTable: lazy(() =>
        import('./components/CollegeSavingsPricesTable/AlaskaPricesTable')
    ),
    AlaskaReturnsTable: lazy(() =>
        import('./components/CollegeSavingsReturnsTable/AlaskaReturnsTable')
    ),
    NationalReturnsTable: lazy(() =>
        import('./components/CollegeSavingsReturnsTable/NationalReturnsTable')
    ),
    NationalPricesTable: lazy(() =>
        import('./components/CollegeSavingsPricesTable/NationalPricesTable')
    ),
    BuyButton: lazy(() => import('./components/BuyButton/BuyButton')),
    LeadGenButton: lazy(() =>
        import('./components/LeadGenButton/LeadGenButton')
    ),
    LeadGenForm: lazy(() => import('./components/LeadGenForm/LeadGenForm')),
    PamForm: lazy(() => import('./components/PamForm/PamForm')),
    ETFSummaryCard: lazy(() =>
        import('./components/ETFSummaryCard/ETFSummaryCard')
    ),
    IClassChart: lazy(() => import('./components/IClassChart/IClassChart'))
};

const EmbeddedStyles = lazy(() =>
    import('./components/EmbeddedStyles/EmbeddedStyles')
);

const propPrefix = /^prop/;

const getPropAttributes = (node) =>
    Object.keys(node.dataset).reduce(
        (acc, cur) =>
            propPrefix.test(cur)
                ? {
                      ...acc,
                      [camelCase(cur.replace(propPrefix, ''))]: JSON.parse(
                          node.dataset[cur]
                      )
                  }
                : acc,
        {}
    );

const targets = Object.keys(componentMap).reduce(
    (acc, componentName) => [
        ...acc,
        ...Array.from(
            document.querySelectorAll(`[data-component=${componentName}]`)
        ).map((node) => ({ componentName, node }))
    ],
    []
);

const loadAll = () => {
    if (!targets.length) return;
    const client = createClient();
    const canvas = document.createElement('div');
    document.body.appendChild(canvas);
    ReactDOM.render(
        <ApolloProvider client={client}>
            <WithUserState>
                {(userState) =>
                    targets.map(({ componentName, node }) => {
                        const TheComponent = componentMap[componentName];
                        const theProps = getPropAttributes(node);
                        return ReactDOM.createPortal(
                            <Suspense fallback={false}>
                                <EmbeddedStyles>
                                    <TheComponent
                                        {...userState}
                                        {...theProps}
                                        embedded
                                    />
                                </EmbeddedStyles>
                            </Suspense>,
                            node
                        );
                    })
                }
            </WithUserState>
        </ApolloProvider>,
        canvas
    );
};

initiateConfig().then(loadAll);



// WEBPACK FOOTER //
// ./src/bootstrapper.js